import React, { useState, useMemo, useCallback } from 'react';
import styled from 'styled-components';

import doorState from 'config/doorState';
import unloadSpeed from 'config/unloadSpeed';

import useInterval from "hooks/useInterval";

import { Text } from 'components/Text';

import LiveCamera from './LiveCamera';

const LIVE_CAMERA_UPDATE_INTERVAL = 5000;

// function preloadImages(images, everyMs = 500) {
//   const preloadImage = (imgSrc) => {
//     const imageToLoad = new Image();
//     imageToLoad.src = imgSrc;
//     return imageToLoad;
//   };

//   const loadedImages = [];
//   images.forEach((imgUrl, index) => {
//     setTimeout(() => {
//       loadedImages[index] = preloadImage(imgUrl);
//     }, everyMs * index);
//   });
// }

const LiveViewCameras = ({ doors, doorsView, doorNameField = 'name' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const liveDoors = useMemo(() => {
    if (!doors) {
      return [];
    }

    const liveDoors = doors.filter(d => d.has_cam === 1);
    const nrOfFavs = liveDoors.reduce((s, d) => s + d.is_favorite, 0);

    if (nrOfFavs > 1) {
      return liveDoors.filter(door => door.is_favorite === 1);
    }
    return liveDoors;
  }, [doors]);

 // preload images
  // useEffect(() => {
  //   if (liveDoors.length && doorsView.length) {
  //     const doorViewImages = doorsView.reduce((images, doorView) => {
  //       const index = liveDoors.findIndex(liveDoor => liveDoor.door_id === doorView.door_id);
  //       if (doorView.url && index !== -1) {
  //         images.push(doorView.url);
  //       }
  //       return images;
  //     }, []);

  //     if (doorViewImages.length > 0) {
  //       preloadImages(doorViewImages, 500);
  //     }
  //   }
  // }, [liveDoors, doorsView]);

  const currentLiveViews = useMemo(() => {
    try {
      const previousIndex = (currentIndex - 2) < 0 ? liveDoors.length - 2 : (currentIndex - 2) % liveDoors.length;
      if (liveDoors.length) {
        const doorViews = [
          liveDoors[currentIndex],
          liveDoors[(currentIndex + 1) % liveDoors.length]
        ];
        const previousDoors = [
          liveDoors[previousIndex],
          liveDoors[(previousIndex + 1) % liveDoors.length]
        ];

        return doorViews.map((liveDoor, index) => ({
          doorName: liveDoor[doorNameField],
          statusColor: doorState.getColor(liveDoor.door_state) || unloadSpeed.getColor(liveDoor.relative_speed),
          img: doorsView.find(doorView => doorView.door_id === liveDoor.door_id)?.url,
          previousDoor: previousDoors[index]?.name,
          previousStatusColor: doorState.getColor(previousDoors[index]?.door_state) || unloadSpeed.getColor(previousDoors[index]?.relative_speed),
          isBorderOnly: liveDoor?.direction === 'LOAD' && liveDoor?.door_state !== doorState.EMPTY,
          previousIsBorderOnly: previousDoors[index]?.direction === 'LOAD' && previousDoors[index]?.door_state !== doorState.EMPTY,
          isStorageEquipment: liveDoor?.container_code === 'Equipment used for Pallets' || liveDoor?.container_code === 'Equipment used for Storage',
          previousIsStorageEquipment:
            previousDoors[index]?.container_code === 'Equipment used for Pallets' ||
            previousDoors[index]?.container_code === 'Equipment used for Storage',
          percentComplete: liveDoor['unloaded_percent'],
          unloadMethod: liveDoor['unload_method'],
          direction: liveDoor['direction'],
        }));
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error in useMemo:", error);
      console.log("currentIndex:", currentIndex);
      console.log("liveDoors:", liveDoors);
      console.log("doorsView:", doorsView);
      return [];
    }
  }, [liveDoors, doorsView, currentIndex, doorNameField]);

  const updateCurrentIndex = useCallback(() => {
    if (liveDoors && liveDoors.length) {
      setCurrentIndex(currentIndex => (currentIndex + 2) % liveDoors.length);
    }
  }, [liveDoors]);

  useInterval(updateCurrentIndex, LIVE_CAMERA_UPDATE_INTERVAL);

  return (
    <LiveViewWrapper>
      <Text style={{ fontSize: '1.4vw', fontWeight: 600, color: '#000', paddingLeft: '0.6vh', paddingBottom: '2vh' }}>
        Live View
      </Text>
      {currentLiveViews[0] && <LiveCamera {...currentLiveViews[0]} />}
      {currentLiveViews[1] && <LiveCamera {...currentLiveViews[1]} />}
    </LiveViewWrapper>
  );
};

const LiveViewWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 100%;

  padding-left: 2.64vh;
  padding-right: 2.64vh;

  & > * {
    padding-bottom: 1.75vh;
  }
`;

export default LiveViewCameras;

